<template>
  <!-- <el-tree
    ref="tree"
    :data="permissionList"
    :show-checkbox="true"
    default-expand-all
    :check-strictly="true"
    node-key="id"
    :default-checked-keys="list"
    :props="defaultProps"
    @check="checkChangeHandler"
  >
  </el-tree> -->
  <el-collapse class="permission-list" v-model="activeNames">
    <el-collapse-item
      v-for="menu in permissionList"
      :key="menu.id"
      :class="['permission-menu', (!menu.childrenNode || !menu.childrenNode.length) ? 'none' : '']"
      :name="menu.id"
      :disabled="!menu.childrenNode || !menu.childrenNode.length">
      <template slot="title">
        <div class="menu-item">
          <div class="menu-item-left">
            <el-checkbox :disabled="!isEdit" class="menu-check" :value="isChekced(menu)" @click.native="stopDefault($event)"  @change="handleCheckChange(menu)"></el-checkbox>
            <img class="icon-fold" src="@/assets/images/icon-fold.png" />
            <span class="menu-name">{{menu.name}}</span>
          </div>
          <!-- <div v-if="menu.buttonList && (menu.buttonList.length > 0)" class="menu-item-right">
            <div v-for="buttonItem in menu.buttonList" :key="buttonItem.id" class="menu-item-right-check">
              <el-checkbox class="menu-check" :value="isChekced(buttonItem)" @click.native="stopDefault($event)"  @change="handleCheckChange(buttonItem)"></el-checkbox>
              <span class="menu-name">{{buttonItem.name}}</span>
            </div>
          </div> -->
        </div>
      </template>
      <!-- 多层级页面 -->
      <div v-if="menu.menuList && (menu.menuList.length > 0)" class="permission-menu-content">
        <div v-for="submenu in menu.menuList" :key="submenu.id" class="permission-menu-content-item">
          <div class="menu-item">
            <div class="menu-item-left">
              <el-checkbox :disabled="!isEdit" class="menu-check" :value="isChekced(submenu)" @click.native="stopDefault($event)"  @change="handleCheckChange(submenu)"></el-checkbox>
              <span class="menu-name">{{submenu.name}}</span>
            </div>
            <div v-if="submenu.buttonList && (submenu.buttonList.length > 0)" class="menu-item-right margin-left-24">
              <div v-for="buttonItem in submenu.buttonList" :key="buttonItem.id" class="menu-item-right-check">
                <el-checkbox :disabled="!isEdit" class="menu-check" :value="isChekced(buttonItem)" @click.native="stopDefault($event)" @change="handleCheckChange(buttonItem)"></el-checkbox>
                <span class="menu-name">{{buttonItem.name}}</span>
              </div>
            </div>
          </div>
          <template v-if="submenu.menuList && (submenu.menuList.length > 0)">
            <div v-for="nodeMenu in submenu.menuList" :key="nodeMenu.id" class="permission-menu-content-item">
              <div class="menu-item">
                <div class="menu-item-left">
                  <el-checkbox
                    :disabled="!isEdit"
                    class="menu-check margin-left-24"
                    :value="isChekced(nodeMenu)"
                    @click.native="stopDefault($event)"
                    @change="handleCheckChange(nodeMenu)"></el-checkbox>
                    <span class="menu-name">{{nodeMenu.name}}</span>
                </div>
                <div v-if="nodeMenu.buttonList && (nodeMenu.buttonList.length > 0)" class="menu-item-right margin-left-48">
                  <div v-for="buttonItem in nodeMenu.buttonList" :key="buttonItem.id" class="menu-item-right-check">
                    <!-- <el-checkbox
                      :disabled="!isEdit"
                      class="menu-check"
                      :value="isChekced(buttonItem)"
                      @click.native="stopDefault($event)"
                      @change="handleCheckChange(buttonItem)"></el-checkbox> -->
                    <span
                      class="ic-checkbox iconfont"
                      :class="[isChekced(buttonItem) ? 'icon-a-xuanzhongyuan' : 'icon-a-weixuanzhongyuan', !isEdit ? 'disabled' : '']"
                      @click="isEdit ? handleCheckChange(buttonItem) : null"></span>
                    <span class="menu-name menu-button">{{buttonItem.name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <!-- 一级页面下按钮 -->
      <div v-if="menu.buttonList && (menu.buttonList.length > 0)" class="permission-menu-content">
        <div v-for="button in menu.buttonList" :key="button.id" class="permission-menu-content-item">
          <div class="menu-item">
            <div class="menu-item-left">
              <el-checkbox :disabled="!isEdit" class="menu-check" :value="isChekced(button)" @click.native="stopDefault($event)"  @change="handleCheckChange(button)"></el-checkbox>
              <span class="menu-name">{{button.name}}</span>
            </div>
          </div>
        </div>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import { Loading } from 'element-ui';

import GlobalData from '@/utils/global/index';
import {
  getParentNodes,
  getChildNodes,
  getParentNode,
  getChildrenNext,
} from '@/views/account/permission/role/role-tree/index';

export default {
  props: {
    list: {
      type: Array,
      default: () => ([]),
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      activeNames: [],
      permissionList: [],
      defaultProps: {
        children: 'childrenNode',
        label: 'name',
      },
      checkedMap: {},
    };
  },
  created() {
    this.fetchPermissionList();
  },
  watch: {
    list(value) {
      this.checkedMap = value.reduce((acc, cur) => {
        acc[cur] = true;
        return acc;
      }, {});
    },
  },
  methods: {
    async fetchPermissionList() {
      const loading = Loading.service();
      try {
        const list = await GlobalData.getPermissionList();
        this.permissionList = this.formatMenu(list);
        this.activeNames = list.filter(item => (item.childrenNode && item.childrenNode.length)).map(item => item.id);
      } catch (err) {
      }
      loading.close();
    },
    // TODO 可用递归来简化
    formatMenu(list) {
      for (let i = 0; i < list.length; i++) { // 一级菜单
        const item = list[i];
        const childrenNode = item.childrenNode || [];
        const menuList = [];
        const buttonList = [];
        for (let j = 0; j < childrenNode.length; j++) { // 二级菜单/按钮
          const submenu = childrenNode[j];
          const subChildrenNode = submenu.childrenNode || [];
          const menuList1 = [];
          const buttonList1 = [];
          for (let n = 0; n < subChildrenNode.length; n++) { // 三级
            const subNode = subChildrenNode[n];
            subNode.menuList = [];
            subNode.buttonList = subNode.childrenNode || []; // 四级 即全是按钮
            if (subNode.menuUrl) { // 页面级别 通过 menuUrl 代替 subNode.resourceType === 1 来判断
              menuList1.push(subNode);
            } else { // 按钮级别
              buttonList1.push(subNode);
            }
          }
          submenu.menuList = menuList1;
          submenu.buttonList = buttonList1;

          if (+submenu.resourceType === 1) { // 页面级别
            menuList.push(submenu);
          } else { // 按钮级别
            buttonList.push(submenu);
          }
        }
        item.menuList = menuList;
        item.buttonList = buttonList;
      }
      return list;
    },
    parentIsChecked(newCheckedItems, parentId) {
      // 获取父节点
      const parentNode = getParentNode(this.permissionList, parentId);
      if (parentNode) {
        // 获取父节点下的所有子页面
        const nodes2 = getChildrenNext(parentNode);
        if (!nodes2.length) {
          return;
        }
        //  获取父节点下的所有子页面中被选中的子菜单
        const nodes2Checked = nodes2.filter((item) => newCheckedItems.includes(item));
        // 如果父节点下没有没有子节点被选中,父节点也不选中
        if (!nodes2Checked.length) {
          newCheckedItems.splice(newCheckedItems.indexOf(parentNode.id), 1);
          // 若还有父节点，需要继续遍历父节点是否需要取消
          this.parentIsChecked(newCheckedItems, parentNode.parentId);
        }
      }
    },
    checkChangeHandler(data) {
      const currentCheckedNodes = this.$refs.tree.getCheckedKeys();
      const checked = currentCheckedNodes.includes(data.id);
      if (checked) {
        // 子节点选中，父节点必定选中
        const parentNodes = getParentNodes(this.permissionList, data.id);
        const childrenNode = getChildNodes(this.permissionList, data.id);
        this.$refs.tree.setCheckedKeys(Array.from(new Set([...currentCheckedNodes, ...parentNodes, ...childrenNode])));
      } else {
        // 父节点不选中，子节点都取消选中
        const childrenNodes = getChildNodes(this.permissionList, data.id);
        const newCheckedItems = currentCheckedNodes.filter((item) => childrenNodes.indexOf(item) < 0);
        // 若父目录下没有一个子页面被选中，父目录也不选中
        if (data.resourceType === 1 && data.parentId !== '0') {
          this.parentIsChecked(newCheckedItems, data.parentId);
        }
        this.$refs.tree.setCheckedKeys(newCheckedItems);
      }
      const checkedList = this.$refs.tree.getCheckedKeys();
      this.$emit('update:list', checkedList);
    },
    getButtonPermission(list) {
      if (!list || !list.length) {
        return;
      }
      const arr = list.filter(item => +item.resourceType === 2).map(item => item.name);
      return arr.join('/');
    },
    stopDefault(event) {
      event.stopPropagation();
    },
    handleCheckChange(data) {
      const resId = data.id;
      if (this.checkedMap[resId]) {
        delete this.checkedMap[resId];
      } else {
        this.checkedMap[resId] = true;
      }
      const checked = !!this.checkedMap[resId]; // 是否选中
      if (checked) {
        // 子节点选中，父节点必定选中
        const parentNodes = getParentNodes(this.permissionList, data.id);
        const childrenNode = getChildNodes(this.permissionList, data.id);
        [...parentNodes, ...childrenNode].forEach(item => {
          this.checkedMap[item] = true;
        });
      } else {
        // 父节点不选中，子节点都取消选中
        const childrenNodes = getChildNodes(this.permissionList, data.id);
        const currentCheckedNodes = Object.keys(this.checkedMap);
        const newCheckedItems = currentCheckedNodes.filter((item) => childrenNodes.indexOf(item) < 0);
        // // 若父目录下没有一个子页面被选中，父目录也不选中
        if (data.resourceType === 1 && data.parentId !== '0') {
          this.parentIsChecked(newCheckedItems, data.parentId);
        }
        this.checkedMap = newCheckedItems.reduce((acc, cur) => {
          acc[cur] = true;
          return acc;
        }, {});
      }

      const list = Object.keys(this.checkedMap);
      this.$emit('update:list', list);
    },
    isChekced(data) {
      return !!this.checkedMap[data.id];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.permission-list {
  .permission-menu {
    margin-bottom: 10px;
    background-color: $color-default;

    &.none {
      ::v-deep .el-collapse-item__header {
        cursor: default;
      }
      ::v-deep .el-collapse-item__arrow {
        display: none;
      }
    }

    .menu-item {
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-wrap: wrap;
      flex-direction: column;

      .menu-item-left {
        display: flex;
        align-items: center;
      }

      .menu-item-right {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        flex-wrap: wrap;
        padding-right: 24px;

        .menu-item-right-check {
          display: flex;
          align-items: center;
          margin-right: 20px;
          white-space: nowrap;
          margin-top: 6px;
          margin-bottom: 6px;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    .menu-check {
      margin-right: 10px;
    }

    .ic-checkbox {
      cursor: pointer;
      margin-right: 10px;
      color: #D4D7DE;

      &.disabled {
        color: #DCDFE6 !important;
        cursor: not-allowed;
      }

      &.icon-a-xuanzhongyuan {
        color: $color-text-default-button;
      }
    }

    .icon-fold {
      width: 21px;
      height: 17px;
      margin-right: 4px;
    }

    .menu-name {
      font-size: 14px;
      font-family: Avenir-Heavy, Avenir;
      font-weight: 800;
      color: $color-text-primary;

      &.menu-button {
        display: flex;
        align-items: center;
        height: 24px;
        padding: 0 10px;
        line-height: 24px;
        background-color: $color-default;
      }
    }

    ::v-deep .el-collapse-item__header {
      padding-left: 25px;
      padding-right: 20px;
      background-color: $color-default;
      border-bottom: none;
      border-top: none;
    }

    ::v-deep .el-collapse-item__wrap {
      border-bottom: none;
    }

    ::v-deep .el-collapse-item__content {
      background-color: $color-default;
      padding-left: 25px;
      padding-right: 20px;
    }

    ::v-deep .el-collapse-item__arrow {
      color: $color-text-default-button;
    }

    ::v-deep .el-collapse-item__arrow.el-icon-arrow-right:before {
      font-family: "iconfont" !important;
      content: "\e672";
      color: #0098C7;
    }

    .permission-menu-content {
      background-color: white;
      padding-left: 25px;
      padding-right: 20px;
      border-radius: 2px;
      padding-bottom: 10px;

      .permission-menu-content-item {
        .menu-item {
          // min-height: 44px;
          padding: 6px 0;
        }
      }

      .permission-submenu {
        display: flex;
        align-items: center;

        .menu-name {
          &.menu-button {
            display: flex;
            align-items: center;
            height: 24px;
            padding: 0 10px;
            background-color: $color-default;
            line-height: 24px;
          }
        }
      }

      .permission-submenu-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
  }
}
</style>
